/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 08.09.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import DocumentTitle from 'react-document-title';

import _get from 'lodash/get';
import _at from 'lodash/at';
import _size from 'lodash/size';
import _chunk from 'lodash/chunk';

import {OpenProfileFor} from '../../actions/common/actions-common';
import {FetchAssetById} from '../../actions/asset/action-asset';
import {Related} from '../../actions/collection/actions-collection';

import Translate from '../../components/Translate';
import DivLoader from '../../components/DivLoader';
import ShowcaseRow from '../../components/ShowcaseCollection/showcase-collection-row';

class ShowcaseRelated extends Component {
  constructor(props) {
    super(props);

    this.state = {
      extendedRow: null
    };
  }

  componentWillMount() {

    this.props.Related(this.props.assetId);
    if (!this.props.assetZero.id) this.props.FetchAssetById(this.props.assetId);

    if (this.props.globalProfile && this.props.globalProfile !== 'related') {

      this._onCollapseRow();
    }
  }

  componentWillReceiveProps(newProps) {

    if (newProps.assetId !== this.props.assetId) {

      this.props.Related(newProps.assetId);
      if (!this.props.assetZero.id) this.props.FetchAssetById(newProps.assetId);

      this._onCollapseRow();
    }

    if (newProps.globalProfile && newProps.globalProfile !== 'related') {

      this._onCollapseRow();
    }
  }

  _onExtendRow(row, col) {

    this.setState({extendedRow: row, extendedCol: col});
    this.props.OpenProfileFor('related');
  }

  _onCollapseRow() {

    this.setState({extendedRow: null, extendedCol: null});
  }

  _renderAssetRows() {
    if (!_size(this.props, 'assets')) {
      return null;
    }

    return _chunk(this.props.assets, '9').map((chunk, index) => {
      return <ShowcaseRow
        key={`row_${index}`}
        assets={chunk}
        row={index}
        onExtendRow={this._onExtendRow.bind(this)}
        isExtend={this.state.extendedRow === index}
        sel_row={this.state.extendedRow}
        sel_col={this.state.extendedCol}
      />
    });
  }

  render() {

    return (<DocumentTitle title={Translate.translator('page.related') + ' | ' + _get(this.props, 'assetZero.title', '')}>
      <div className="asset-showcase" style={{position: 'relative'}}>
        <div id="showcase-header" className="blocks-row clearfix">
          <ul className="menu block-3 radius bg-black">
            <li className="block-1">
              <a className="pad-lr hover pointer">
                <span className="icon">
                   <i className="ic ic-vod-related ic-24px" style={{position: 'relative', top: '14px'}}></i>
                </span>
              </a>
            </li>
            <li className="block-1">
              <a className="pad-lr hover container pointer">
                <span> <strong> <Translate content='related' /> </strong></span>
              </a>
            </li>
            <li className="block-1 col-last">
              <a className="pad-lr container">
                <span> <strong> {this.props.assetZero.title} </strong></span>
              </a>
            </li>
          </ul>
        </div>
        <div id="showcase-row-container">
          {this._renderAssetRows()}
        </div>
        { (this.props.inProgress) &&
        <div className="profile-container">
          <div id="showcase_row" style={{height: '132px', position: 'relative'}}>
            <div className="blocks-row clearfix showcase-row radius" style={{height: '100%'}}>
              <DivLoader loading={this.props.inProgress} />
            </div>
          </div>
        </div>
        }
        { (!this.props.inProgress && !_size(this.props.assets) ) && <div id="showcase-empty-container">
          <div className="ui dimmer visible active radius">
            <div className="content">
              <div className="center">
                <h2 className="ui inverted icon header">
                  <Translate content="empty_result" />
                </h2>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </DocumentTitle>);
  }
}

ShowcaseRelated.propTypes = {
  /**
   * @connect props
   */
  assetZero: PropTypes.object,
  assets: PropTypes.array.isRequired,
};

ShowcaseRelated.defaultProps = {
  /**
   * @connect props
   */
  assetZero: {},
  assets: []
};

const mapStateToProps = ({assets, collections: {related}, common: {profile}}, ownProps) => {

  let collection = _get(related, 'collection', []);
  let assetEntities = _at(assets, collection);

  return {
    globalProfile: profile,
    assetZero: _get(assets, ownProps.assetId, {}),
    assets: assetEntities,
    search: collection,
    inProgress: !!related.inProgress
  }
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({Related, FetchAssetById, OpenProfileFor}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowcaseRelated);



// WEBPACK FOOTER //
// ./src/containers/ShowcaseRelated/showcase-related.js